export function separateByComma(stringOfNumbers: string): string {
    // Reverse the string to make it easier to insert commas from the right
    const reversedString: string = stringOfNumbers.split("").reverse().join("");

    // Split the reversed string into chunks of three characters each
    const chunks: string[] = [];
    for (let i = 0; i < reversedString.length; i += 3) {
        chunks.push(reversedString.slice(i, i + 3));
    }

    // Join the chunks with commas and reverse the result to get the desired output
    const result: string = chunks.join(",").split("").reverse().join("");

    return result;
}
